import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import PortfolioBg from "../../assets/img/Our-Services.jpg";
import { projects } from "../../data/projects";

function ProjectCard({ project }) {
  return (
    <article className="group overflow-hidden bg-white shadow-sm">
      <Link to={`/portfolio/${project.slug}`} className="block focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary" aria-label={`View ${project.title} project`}>
        <div className="aspect-[4/3] overflow-hidden bg-gray">
          {project.image ? <img src={project.image} alt={`${project.category} project`} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" /> : <div className="flex h-full items-center justify-center text-secondary/50">Project image</div>}
        </div>
        <div className="p-6 md:p-8">
          {/* <p className="mb-3 text-xs font-semibold uppercase tracking-[0.16em] text-primary">{project.category}</p> */}
          <div className="flex items-start justify-between gap-4">
            <h2 className="text-2xl font-semibold text-secondary">{project.title}</h2>
            <ArrowUpRight aria-hidden="true" className="mt-1 shrink-0 text-primary transition-transform group-hover:-translate-y-1 group-hover:translate-x-1" />
          </div>
          <p className="mt-3 leading-relaxed text-secondary/75">{project.description}</p>
          <span className="mt-6 inline-block border-b border-primary pb-1 text-sm font-semibold text-primary">View project</span>
        </div>
      </Link>
    </article>
  );
}

export default function Portfolio() {
  useEffect(() => {
    document.title = "Our Portfolio | Zenera";
    let description = document.querySelector('meta[name="description"]');
    if (!description) { description = document.createElement("meta"); description.name = "description"; document.head.appendChild(description); }
    description.content = "Explore Zenera projects across communications, brand strategy, public relations and community engagement.";
  }, []);

  return <div>
    <Navbar />
    <div className="hidden h-[80px] bg-[#F7F7F7] md:block" />
    <header className="relative flex h-[300px] items-center justify-center overflow-hidden md:h-[440px]">
      <div className="relative w-full h-[200px] md:h-[480px] overflow-hidden group ">
        <img
          src={PortfolioBg}
          alt="Background"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />

        <div className="absolute inset-0 flex bg-primary bg-opacity-60 items-center justify-center  duration-500">
          <h1 className="text-white text-4xl md:text-6xl font-bold text-center duration-500">
            Our Portfolio
          </h1>
        </div>
      </div>
    </header>
    <main className="container mx-auto px-4 py-16 md:px-8 md:py-24">
      <div className="mb-10 flex flex-col justify-between gap-4 md:mb-14 md:flex-row md:items-end">
        <div><p className="mb-2 text-sm font-semibold uppercase tracking-[0.16em] text-primary">What we do</p><h2 className="text-3xl font-semibold text-secondary md:text-4xl">Ideas made impactful.</h2></div>
        <p className="max-w-xl text-secondary/70">Explore our capabilities. These case studies show how project details are presented.</p>
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 md:gap-8">
        {projects.map((project) => <ProjectCard key={project.id} project={project} />)}
      </div>
    </main>
    <Footer />
  </div>;
}
